export interface UserCommunicationSecurityAccessRole {
  userCommunicationSecurityAccessRoleId?: string;
  userCommunicationId: string;
  accessRoleId: string;
}
